<template>
  <div class="footer-section">
    <div class="blue-bar">
      <div class="container">
        <el-row>
          <el-col
            :sm="24"
            :md="12"
            class="left-feed-back-link"
          >
            <a
              :href="getBeWellDoncasterPageUrl('/for-my-organisation/contact-us-cwb')"
              target="_blank"
            >
              Give feedback about this website
              <svg-external-white class="external-link"></svg-external-white>
            </a>
          </el-col>
          <!--el-col :sm="24" :md="12" class="right-feed-back-link">
            <a href="https://www.surveymonkey.co.uk/r/GSBETA" target="_blank">Is there something wrong with this page?</a>
          </!--el-col-->
        </el-row>
      </div>
    </div>
    <div class="container footer-inner">
      <el-row>
        <el-col
          :sm="24"
          :md="8"
        >
          <ul class="footer-links">
            <li>
              <a
                :href="
                  getBeWellDoncasterPageUrl('/for-my-organisation')
                "
              >
                About CWB
              </a>
            </li>
            <li>
              <a
                :href="
                  getBeWellDoncasterPageUrl(
                    '/for-my-organisation/events-training'
                  )
                "
                target="_blank"
              >
                Events & training
              </a>
            </li>
            <li>
              <a
                :href="
                  getBeWellDoncasterPageUrl(
                    '/for-my-organisation/becoming-a-member'
                  )
                "
                target="_blank"
              >
                Becoming a member
              </a>
            </li>
            <li>
              <a
                :href="
                  getBeWellDoncasterPageUrl(
                    '/for-my-organisation/cwb-meet-the-team'
                  )
                "
                target="_blank"
              >
                Meet the team
              </a>
            </li>
            <li>
              <a
                :href="getBeWellDoncasterPageUrl('/contact')"
                target="_blank"
              >
                Contact us
              </a>
            </li>
          </ul>
        </el-col>
        <el-col
          :sm="24"
          :md="8"
        >
          <ul class="footer-links">
            <li>
              <a :href="getBeWellDoncasterPageUrl('/for-me')">
                BeWell
              </a>
            </li>
            <li>
              <a
                :href="getBeWellDoncasterPageUrl('/for-my-community')"
                target="_blank"
              >
                Well Doncaster
              </a>
            </li>
          </ul>
        </el-col>
        <el-col
          :sm="24"
          :md="8"
        >
          <div class="social-icons">
            <a
              aria-label="facebook icon"
              href="https://www.facebook.com/commwealthbuild/"
              target="_blank"
            >
              <svg-facebook
                class="social-icon"
                title="Facebook icon"
              ></svg-facebook>
            </a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24">
          <div class="horizontal-links">
            <router-link :to="{ name: 'Accessibility' }">
              Accessibility
            </router-link>
            <router-link :to="{ name: 'Cookie Policy' }">
              Cookies
            </router-link>
            <router-link :to="{ name: 'Privacy Policy' }">
              Privacy
            </router-link>
            <router-link :to="{ name: 'Terms & Conditions' }">
              Terms
            </router-link>
          </div>

          <!--div class="d-flex se-logos">
            <a href="https://www.scottish-enterprise.com/" target="_blank">
              <img
                src="../../static/img/se-logo.png"
                class="se-logo"
                alt="Scottish Enterprise Logo"
              />
            </a>
            <a href="https://www.sdi.co.uk/" target="_blank">
              <img
                src="../../static/img/scottish-development-logo.png"
                class="sd-logo"
                alt="Scottish Development International Logo"
              />
            </a>
          </!--div-->
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import svgFacebook from "@/components/assets/svg-facebook";
import svgExternalWhite from "@/components/assets/svg-link";

export default {
  components: {
    "svg-facebook": svgFacebook,
    "svg-external-white": svgExternalWhite,
  },
  computed: {
    getBeWellDoncasterPageUrl() {
      return (page = null) => {
        return `${process.env.VUE_APP_BE_WELL_CMS_URL}${page ? page : ""}`;
      };
    },
  },
};
</script>
